import PromoBoxDash from './CumulPromoBoxDashboard';

export const CumulPromoBoxDashboard = PromoBoxDash;
